import { render, staticRenderFns } from "./EventCategoryDetails.vue?vue&type=template&id=8775b18e&scoped=true&"
import script from "./EventCategoryDetails.vue?vue&type=script&lang=js&"
export * from "./EventCategoryDetails.vue?vue&type=script&lang=js&"
import style0 from "./EventCategoryDetails.vue?vue&type=style&index=0&id=8775b18e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8775b18e",
  null
  
)

export default component.exports